import YesIcon from 'assets/images/yes-icon.svg';
import SuccessImage from 'assets/images/create-success.svg';
import CancelRenewalImage from 'assets/images/cancel-renewal-v2.svg';
import CanceSubslImage from 'assets/images/sad-smiley.svg';
import ThumbsupImage from 'assets/images/thumbsup-smiley.svg';
import Logo from 'assets/images/logo.svg';
import FooterLogo from 'assets/images/footer-logo.svg';
import LoginLogo from 'assets/images/login-logo.svg';
import SubscribiliLogo from 'assets/images/logo-subscribili.png';
import Theme from 'theme';

const {
  REACT_APP_GROUP_ID: groupId,
  REACT_APP_AWS_REGION: region,
  REACT_APP_COGNITO_POOL_ID: userPoolId,
  REACT_APP_COGNITO_WEB_CLIENT_ID: userPoolWebClientId,
  REACT_APP_CLIENT_HEADER: clientHeader = groupId,
  REACT_APP_APPPOINTMENT_LINK: bookAppointmentLink,
} = process.env;

const config = {
  groupId,
  region,
  userPoolId,
  userPoolWebClientId,
  logo: Logo,
  cptCodesIcon: YesIcon,
  portalName: 'Forest Family Dentistry',
  // Industry drives the Strapi FAQ template (SAP-7671). Omit to default to 'dental'.
  // Valid: dental | primary-care | chiropractic | dermatology | urgent-care | veterinary
  industry: 'dental',
  tokenName: 'forestfamilydentistrySubscriberToken',
  globalClass: 'group-parent-container',
  clientHeader,
  enableHeroButton: true,
  pricingType: 'standard-pricing',
  showAddressSuggestion: true,
  heroLocaleColor: 'secondary',
  splitPlans: false,
  headerProps: {
    enable: true,
    showLogin: false,
  },
  localeProps: {},
  homeTemplateProps: {
    heroSection: {
      variant: 2,
      titleClasses: 'home-hero-title',
      subTitleClasses: 'home-hero-subtitle',
      primaryButtonProps: {
        to: '/find-a-provider',
      },
      secondaryButtonProps: {
        to: '/login',
        color: 'secondary',
        variant: 'contained',
      },
      background: '/images/home-images/home-banner-img.webp',
      backgroundMobile: '/images/home-images/home-banner-img-mobile.webp',
    },
    benefitsSection: {
      variant: 3,
      columns: 2,
      alignTitle: 'left',
      alignCard: 'left',
      heroImage: '/images/home-images/benefits-hero.webp',
      heroImageMobile: '/images/home-images/benefits-hero-mobile.webp',
    },
    subscriptionSection: {
      priority: 'top',
      renderAsTabsLimit: 4,
      cardVariant: 2,
      tabVariant: 1,
      disableGroupSavings: true,
      carouselResponsiveItems: {
        desktop: 1,
      },
      showAddons: false,
      primaryButtonProps: {
        color: 'primary',
        variant: 'contained',
      },
      planCardProps: {
        buttonProps: {
          customSpace: 11,
          normalVariant: 'contained',
          normalColor: 'primary',
          to: '/find-a-provider',
        },
      },
    },
    howItWorksSection: {
      variant: 2,
      heroImage: '/images/home-images/how-it-works.webp',
      alignTitle: 'left',
    },
    testimonialSection: {
      enable: false,
    },
    staticHeroSection: {
      enable: true,
      variant: 1,
      alignTitle: 'left',
      primaryButtonProps: {
        color: 'primary',
      },
    },
  },
  checkoutSection: {},
  findProviderSection: {
    locationWrapper: 7,
    mapWrapper: 5,
    iconProps: {
      url: '/images/map-loc-icon.svg',
    },
  },
  choosePlanSection: {
    sectionSubtitle: '',
    locationLogo: Logo,
    cardVariant: 1,
    tabVariant: 2,
    planCardProps: {
      buttonProps: {
        normalColor: 'primary',
        highlightedColor: 'primary',
        normalVariant: 'contained',
        highlightedVariant: 'outlined',
      },
    },
    staticHeroSection: {
      enable: true,
      variant: 1,
      primaryButtonProps: {
        color: 'primary',
      },
    },
  },
  subscriptionSuccess: {
    successImage: SuccessImage,
    enableBookAppointment: true,
  },
  savingsSummary: {
    enableFooterbar: true,
    showCategoryHeaders: true,
    showPlanDiscHeader: true,
    contactSection: 'contactDetails',
    buttonProps: {
      variant: "outlined",
      color: "secondary",
      size: "large",
    },
  },
  faqSection: {},
  dashboardProps: {
    showBenefitsUsage: true,
    cancelRenewal: {
      image: CancelRenewalImage,
    },
    cancelSubscription: {
      image: CanceSubslImage,
    },
    reactivateRenewal: {
      image: ThumbsupImage,
    },
  },
  bookAppointment: {},
  footer: {
    enable: true,
    logo: FooterLogo,
    subscribiliLogo: SubscribiliLogo,
  },
  loginPage: {
    bannerImage: './images/login.webp',
    logo: LoginLogo,
  },
  theme: Theme,
};

export default config;
